// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__HIuY4","name":"Header_name__1SDSF","birthday":"Header_birthday__E3cRa","skeleton":"Header_skeleton__3HNFT"};